import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconPaperclip = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconPaperclip.dimensions.width} ${IconPaperclip.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M16.552 1.448a4.956 4.956 0 0 1 0 7.002l-9.67 9.67a3.544 3.544 0 0 1-5 0 3.544 3.544 0 0 1 0-5.002l9.668-9.67a2.133 2.133 0 0 1 3.001 0 2.133 2.133 0 0 1 0 3.002l-9.336 9.335a.708.708 0 1 1-1-1l9.336-9.336a.69.69 0 0 0 0-1 .69.69 0 0 0-1 0l-9.67 9.67c-.84.84-.84 2.16 0 3 .84.84 2.161.84 3.001 0l9.67-9.67a3.513 3.513 0 0 0 0-5 3.513 3.513 0 0 0-5.002 0l-9.336 9.335a.706.706 0 0 1-1.157-.77.708.708 0 0 1 .157-.23L9.55 1.448a4.956 4.956 0 0 1 7.002 0Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

IconPaperclip.dimensions = {
  width: 18,
  height: 20,
}

export default IconPaperclip
